// Paid-ad landing traffic keeps the original inline SMS disclosure (no consent
// checkboxes) so the funnel these campaigns were tuned against stays unchanged.
const AD_TRAFFIC_SOURCES = ['meta', 'facebook', 'google']

export const isAdTrafficSource = (...sources: (string | null | undefined)[]): boolean =>
  sources.some((source) => !!source && AD_TRAFFIC_SOURCES.includes(source.toLowerCase()))
